import { render, staticRenderFns } from "./BooleanFilter.vue?vue&type=template&id=31f36834&lang=html&"
import script from "./BooleanFilter.vue?vue&type=script&lang=js&"
export * from "./BooleanFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports